import DashboardLayout from '@layouts/dashboard/dashboard-layout';
import React, { useEffect, useState } from 'react';
import './dashboard.scss';
import InfoSection from './components/info';
import TaskSection from './components/tasksection';
import ReportsummarySection from './components/reportsummary';
import { convertDate } from '@common/date-helpers';
import { QueryRequestHelper } from '@common/query-request-helper';
import { dashboardUsereSummary } from '@services/dashboard.service';
import { getValue } from '@utils/lodash';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Loader from '@components/common/Loader';
import DashboardQuickAddSection from './components/quick-add';
import NoAccessPage from '@components/common/NoAccess';
import Select, { StylesConfig } from 'react-select';
import DashboardTabs from './components/dashboard-tabs';

function ClientDashboard(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  const navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [info, setInfo] = React.useState<[]>([]);
  const [tripInfo, setTripInfo] = useState({});
  const [expenseCategoryInfo, setExpenseCategoryInfo] = useState({});
  const [currentView, setCurrentView] = useState('employee'); // default view as employee

  const viewOptions = [
    { value: 'employee', label: 'Employee' },
    { value: 'approver', label: 'Approver' },
  ];

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: '32px',
      height: '32px',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      height: '32px',
      padding: '0 6px',
    }),
    input: (provided: any) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: '32px',
    }),
  };

  const handleViewChange = (selected: any) => {
    setCurrentView(selected.value);

    // Create new URLSearchParams object from current URL params
    const searchParams = new URLSearchParams(window.location.search);

    // Update or add the view_type parameter
    searchParams.set('view_type', selected.value);

    // Navigate to the new URL with updated params
    navigate(`${window.location.pathname}?${searchParams.toString()}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (Object.keys(urlParams).length === 0 && props.permissionAPITriggered) {
      const currentMonth = moment().startOf('month');
      const firstDay: any = currentMonth.format('YYYY-MM-DD');
      const lastDay: any = currentMonth.endOf('month').format('YYYY-MM-DD');
      setFirstDay(firstDay);
      setLastDay(lastDay);
      getData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    if (Object.keys(urlParams).length > 0 && props.permissionAPITriggered) {
      const currentMonth = moment().startOf('month');
      const firstDay: any = currentMonth.format('YYYY-MM-DD');
      const lastDay: any = currentMonth.endOf('month').format('YYYY-MM-DD');
      let from = urlParams.from_date
        ? new Date(urlParams.from_date)
        : new Date(firstDay);
      let to = urlParams.to_date
        ? new Date(urlParams.to_date)
        : new Date(lastDay);
      setFirstDay(from);
      setLastDay(to);
      getData();
    }
  }, [window.location.href, props.permissionAPITriggered]);

  useEffect(() => {
    // Get view_type from URL params if it exists
    const viewType = urlParams.view_type;
    if (viewType && (viewType === 'employee' || viewType === 'approver')) {
      setCurrentView(viewType);
    }
  }, [urlParams]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const monthLabels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const [dashboardInfo, setDashboardInfo] = useState({});
  const getData = async () => {
    const currentMonth = moment().startOf('month');
    const firstDay = currentMonth.format('YYYY-MM-DD');
    const lastDay = currentMonth.endOf('month').format('YYYY-MM-DD');

    let from = urlParams.from_date ? new Date(urlParams.from_date) : firstDay;
    let to = urlParams.to_date ? new Date(urlParams.to_date) : lastDay;
    try {
      setIsLoading(true);
      let payload = {
        // from_date: convertDate(from),
        // to_date: convertDate(to),
      };
      let queryRequest = QueryRequestHelper(payload);
      let userResponse = await dashboardUsereSummary(queryRequest);
      if (userResponse) {
        setDashboardInfo(getValue(userResponse, `data`, {}));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [from_date, setFirstDay] = React.useState(new Date());
  const [to_date, setLastDay] = React.useState(new Date());

  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    let first = moment(from_date).format('YYYY-MM-DD');
    let last = moment(to_date).format('YYYY-MM-DD');
    if (first && last && first !== 'Invalid date' && last !== 'Invalid date') {
      let payload: any = {
        from_date: first,
        to_date: last,
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error('Start Date and End Date Required');
      }
    } else {
      toast.error('Please select date');
    }
  };

  console.log(getValue(props, `tabPermissionList`, []), 'tabPermissionList');

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes('dashboard') ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center justify-content-between w-100">
              <h4 className="dashbaord-wrapper__header-title">Dashboard</h4>
              {getValue(props, 'tabPermissionList', []).includes(
                'approvals',
              ) && (
                <>
                  {/* <div className="mx-3 border-start" style={{height: '20px'}}></div> */}
                  <div className="d-flex align-items-center gap-2">
                    <h6 className="small_text__14 color_primary mt-1 me-2">
                      View as:
                    </h6>
                    <Select
                      styles={customStyles}
                      options={viewOptions}
                      onChange={(e: any) => handleViewChange(e)}
                      value={viewOptions.find(
                        (item) => item.value === currentView,
                      )}
                      isClearable={false}
                    />
                  </div>
                </>
              )}
            </div>
            <div>
              <h3 className="dashboard-compliance__date dashboard-compliance__date--compliance overview-wrapper__header-date d-flex align-items-center">
                <div className="d-flex">
                  {/* <DatePicker
                selectsRange={true}
                startDate={from_date}
                endDate={to_date}
                className="react-date-picker__inputGroup__input_dashboard"
                onChange={(update: any) => {
                  handleDate(update);
                }}
                dateFormat="d MMM yyyy"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
              <button
                className="dashboard-wrapper__apply-btn"
                onClick={handleSubmitDate}
              >
                Apply
              </button> */}
                </div>
              </h3>
            </div>
          </div>
          <div
            className="dashbaord-wrapper_section_container"
            style={{ padding: '20px !important' }}
          >
            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : (
              <div className="">
                {/* <InfoSection /> */}
                {/* {currentView !== 'approver' && <DashboardQuickAddSection />} */}
                {/* <div className="border_bottom mt-3 mb-3"></div> */}
                {/* <TaskSection dashboardInfo={dashboardInfo} /> */}
                <DashboardTabs
                  currentView={currentView}
                  subTabPermissionList={getValue(
                    props,
                    'subTabPermissionList',
                    [],
                  )}
                />
                {/* <ReportsummarySection /> */}
              </div>
            )}
          </div>
        </>
      )}
    </DashboardLayout>
  );
}

export default ClientDashboard;
